import React from 'react';
import styled from 'styled-components';
import { AddButton } from 'components/atoms/button';

const Heading = styled.p`
  font-weight: var(--font-weight-bold);
  font-size: 16px;
  line-height: 22px;
`;

export const HWorkflows = () => {
  return (
    <>
      <div
        style={{
          display: 'flex',
          width: '100%',
          justifyContent: 'space-between',
          borderBottom: '1px solid gray',
          padding: '19px 0',
        }}
      >
        <Heading />
        <AddButton />
      </div>
    </>
  );
};
